<mf-page title="Editar plantilla de pdf">
  @if (templatePdfDto) {
    <mf-template
      [templateDto]="templatePdfDto"
      (save)="save($event)"
      (closeButtonClick)="close()" />
  }
</mf-page>
